import { gql } from '@efficiently/client-core-graphql-models';

export const PROJECT_DESIGN_CHANGE_ITEM_DISPLAY_FIELDS = gql(`
	fragment ProjectDesignChangeItemDisplay on ProjectDesignChangeItem {
		eventType
		itemLabel
		itemLabelColor
		itemName
		itemDescription
		itemImage
		locations {
			index
			roomName
			roomLevel
			roomUnit
			roomClarification
			spaceNumber
			spaceName
			spaceClarification
		}
		beforeText
		afterText
		targetLocation {
			index
			roomName
			roomLevel
			roomUnit
			roomClarification
			spaceNumber
			spaceName
			spaceClarification
		}
		locationLabel
		locationLabelColor
	}
`);
